import axios from "axios";
import { API_ENDPOINTS } from "../../config/api";
import { CommentsAdapter, CommentCreatePayload, CommentRecord } from "./types";

function normalizeComments(data: unknown): CommentRecord[] {
  if (!Array.isArray(data)) {
    return [];
  }

  return data as CommentRecord[];
}

export function createBlogCommentsAdapter(blogId: string, token?: string | null): CommentsAdapter {
  return {
    async fetchComments() {
      const response = await axios.get(API_ENDPOINTS.BLOG.THOUGHTS_GET(blogId));
      return normalizeComments(response.data);
    },

    async postComment(payload: CommentCreatePayload) {
      const response = await axios.post(
        API_ENDPOINTS.BLOG.THOUGHTS,
        {
          blogId,
          userId: payload.userId,
          commentText: payload.commentText,
          nestedId: payload.nestedId,
        },
        {
          withCredentials: true,
          headers: token ? { Authorization: `Bearer ${token}` } : undefined,
        }
      );
      return response.data as CommentRecord;
    },

    async deleteComment(commentId: string, userId: string) {
      await axios.delete(`${API_ENDPOINTS.BLOG.THOUGHTS}/${commentId}`, {
        data: { userId },
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      });
    },

    async reportComment(commentId: string, payload: { userId: string; message: string }) {
      await axios.post(
        `${API_ENDPOINTS.BLOG.THOUGHTS}/${commentId}/report`,
        payload,
        { headers: token ? { Authorization: `Bearer ${token}` } : undefined }
      );
    },
  };
}

export function createPodcastCommentsAdapter(podcastId: string, token?: string | null): CommentsAdapter {
  return {
    async fetchComments() {
      const response = await axios.get(API_ENDPOINTS.PODCAST.COMMENTS(podcastId));
      return normalizeComments(response.data);
    },

    async postComment(payload: CommentCreatePayload) {
      const response = await axios.post(
        API_ENDPOINTS.PODCAST.COMMENTS_POST,
        {
          podcastId,
          userId: payload.userId,
          commentText: payload.commentText,
          nestedId: payload.nestedId,
        },
        {
          withCredentials: true,
          headers: token ? { Authorization: `Bearer ${token}` } : undefined,
        }
      );
      return response.data as CommentRecord;
    },

    async deleteComment(commentId: string, userId: string) {
      await axios.delete(`${API_ENDPOINTS.PODCAST.COMMENTS_POST}/${commentId}`, {
        data: { userId },
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      });
    },

    async reportComment(commentId: string, payload: { userId: string; message: string }) {
      await axios.post(
        `${API_ENDPOINTS.PODCAST.COMMENTS_POST}/${commentId}/report`,
        payload,
        { headers: token ? { Authorization: `Bearer ${token}` } : undefined }
      );
    },
  };
}
